<div class="container-fluid">
    @if (loading) {
        <spinner></spinner>
    } @else if (loadError) {
        <div class="contract-detail-message alert alert-warning" role="alert" tabindex="-1" #message
             data-testid="contract-detail-error">
            <h1 class="h4">{{ loadError === 'denied' ? 'Access denied' : (loadError === 'not-found' ? 'Contract not found' : 'Contract unavailable') }}</h1>
            <p class="mb-2">{{ errorMessage }}</p>
            <a [routerLink]="listRoute" data-testid="contract-back-to-list">Back to contracts</a>
        </div>
    } @else if (contract) {
        <h1 class="h4 pb-3">
            {{ contract.title }}
            @if (statusLabel) {
                <span class="badge text-bg-secondary ms-2 contract-status-badge" data-testid="contract-status-badge">{{ statusLabel }}</span>
            }
        </h1>

        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" aria-label="Contract sections">
            <li ngbNavItem="general">
                <button ngbNavLink type="button" data-testid="contract-tab-general">General details</button>
                <ng-template ngbNavContent>
                    <div class="contract-detail-card">
                        <cdss-contract-form idPrefix="contract-detail"
                                            [contract]="contract"
                                            [readOnly]="!isEditable"
                                            [codeReadOnly]="!canEditCode"
                                            [saving]="saving"
                                            [codeError]="codeError"
                                            (save)="onSave($event)">
                            @if (canDelete) {
                                <cdss-contract-delete-panel [contract]="contract" (deleted)="onDeleted()"></cdss-contract-delete-panel>
                            }
                        </cdss-contract-form>
                    </div>
                </ng-template>
            </li>
            @if (canViewOrganisations) {
                <li ngbNavItem="organisations">
                    <button ngbNavLink type="button" data-testid="contract-tab-organisations">Organisations</button>
                    <ng-template ngbNavContent>
                        <cdss-contract-organisations-tab [contract]="contract" (changed)="load()"></cdss-contract-organisations-tab>
                    </ng-template>
                </li>
            }
            @if (canManageAdmins) {
                <li ngbNavItem="admins">
                    <button ngbNavLink type="button" data-testid="contract-tab-admins">Contract admins</button>
                    <ng-template ngbNavContent>
                        <cdss-contract-admins-tab [contract]="contract"></cdss-contract-admins-tab>
                    </ng-template>
                </li>
            }
            @if (canViewHistory) {
                <li ngbNavItem="history">
                    <button ngbNavLink type="button" data-testid="contract-tab-history">History</button>
                    <ng-template ngbNavContent>
                        <cdss-contract-history-tab [contract]="contract" (changed)="load()"></cdss-contract-history-tab>
                    </ng-template>
                </li>
            }
        </ul>
        <div class="contract-detail-panel">
            <div [ngbNavOutlet]="nav"></div>
        </div>
    }
</div>
